/**
 * A global namespace for `pointerup` event.
 * @type {string}
 */
const pointerupEvent = 'pointerup';
export default pointerupEvent;
